import React from 'react';

/* 1x1 transparent gif — swapped in on error so the broken-image glyph never shows;
   a brand gradient fills the (CSS-fixed 120px) tile behind the .casino-name label. */
const BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export default function GameTile({ game }) {
  return (
    <div className="csn_thumb">
      <img
        className="img-fluid"
        src={game.img}
        alt={game.name}
        loading="lazy"
        onError={(e) => {
          const el = e.currentTarget;
          el.onerror = null;
          el.src = BLANK;
          el.style.background = 'linear-gradient(135deg, var(--theme-secondary-color, #6D081D) 0%, var(--theme-primary-color, #C10930) 100%)';
          el.style.height = '120px';
        }}
      />
      <div className="casino-name">{game.name}</div>
    </div>
  );
}
